import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";
import { NumberLiteralType } from "typescript";


export class committeepermenantInvitees extends EntityDto implements IEntityDto {
  Invitee_Id: string;
  Committee_Id: string;
  CommitteeName: string;
  Emp_Ref_Id: string|undefined;
  EmployeeName: string|undefined;
  DepartmentName: string;
  DesignationName: string
  Designation_Id: string;
  Department_Id: string; 
  InviteeEditBit: number;
  PermenantInvInChargeTill_Id: number;
  PermenantInviteeJoiningDateStr:string|null="";
  PermenantInviteeInChargeTillDateStr:string|null="";
  PermenantInvExpiryDate: Date;
  TenureDatePerm:string|null=''; 
  PermenantInvExpiryTenure: number;
  PermenantInvname: string;
  PermenantInvExpiryType: string;
  PermenantInvExpiry_Id: number; 
  PermenantInvJoiningDate:  Date ;
  PermenantInvJoiningDateStr:  string | null = "";
  PermenantInvInChargeTillDate: Date|null ;
  PermenantInvInChargeTillDateStr:string | null = "";
  PermenantInvInChargeTillTenure: number;
  PermenantInviteeInChargeTillTenure:number;
  PermenantInviteeJoiningDate:Date;
  PermenantInviteeInChargeTillDate:Date|null;
  PermenantInvInChargeTillTenureDate: string|null='';
  IsActive: boolean;
  UserName: string;
  constructor() {
    super();
    this.Invitee_Id = '00000000-0000-0000-0000-000000000000';
    this.Committee_Id = '00000000-0000-0000-0000-000000000000';
    this.CommitteeName = '';
    this.Emp_Ref_Id = '';
    this.DepartmentName = '';
    this.DesignationName = '';
    this.Designation_Id = '';
    this.Department_Id = '';
    this.IsActive = true;
    this.EmployeeName = ''; 
    this.InviteeEditBit=0;
    this.PermenantInvInChargeTill_Id = 0;
    this.PermenantInvExpiryDate = new Date();
    // this.TenureDatePerm='';
    this.PermenantInvExpiryTenure = 0;
    this.PermenantInvname = '';
    this.PermenantInvExpiryType = '';
    this.PermenantInvExpiry_Id = 0; 
    this.PermenantInvJoiningDate = new Date();
    this.PermenantInvInChargeTillDate = null;
    this.PermenantInvInChargeTillTenure = 0;
    this.UserName = "";
    this.PermenantInviteeJoiningDate=new Date();
    this.PermenantInviteeInChargeTillDate= null;
    this.PermenantInviteeInChargeTillTenure=0;
    this.EntityMetaData = [
      { FieldName: 'CommitteeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Committee is required' },
      // { FieldName: 'Department_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department Name is required' },
      { FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Member is required' },



    ];
  }
}